import 'devextreme/dist/css/dx.common.css'
import './themes/generated/theme.base.css'
import './themes/generated/theme.additional.css'
import './dx-styles.scss'

import React, { useEffect } from 'react'
import { BrowserRouter as Router, useLocation } from 'react-router-dom'
import LoadPanel from 'devextreme-react/load-panel'
import { NavigationProvider } from './contexts/navigation'
import { AuthProvider, useAuth } from './contexts/auth'
import { useScreenSizeClass } from './utils/media-query'
import { SleekPlan } from './components'
import UnauthenticatedContent from './UnauthenticatedContent'
import Maintenance from './Maintenance'

import Content from './Content'
import { socketGet } from './socket'

function App() {
	const socket = socketGet()
	const location = useLocation()
	const { user, loading, maintenance, setMaintenance, setNotAllowed } = useAuth()

	useEffect(() => {
		setNotAllowed(null)
	}, [location.pathname, location.search, setNotAllowed])

	useEffect(() => {
		// Set up maintenance callback for Axios interceptor
		import('./api/auth').then(auth => {
			auth.setMaintenanceCallback(setMaintenance)
			auth.setNotAllowedCallback(setNotAllowed)
		})

		const handlerMaintenance = (payload: any) => {
			setMaintenance(payload.state === 'Started')
		}

		if (socket) {
			socket.on('maintenance', handlerMaintenance)

			return () => {
				socket.off('maintenance', handlerMaintenance)
			}
		}
	}, [socket, setMaintenance, setNotAllowed])

	if (maintenance) {
		return <Maintenance />
	}

	if (loading) {
		return <LoadPanel visible={true} />
	}

	if (user) {
		return <Content />
	}

	return <UnauthenticatedContent />
}

export default function Root() {
	const screenSizeClass = useScreenSizeClass()

	return (
		<Router>
			<AuthProvider>
				<NavigationProvider>
					<div className={`app ${screenSizeClass}`}>
						<SleekPlan />
						<App />
					</div>
				</NavigationProvider>
			</AuthProvider>
		</Router>
	)
}
